app.controller('unsignedDocsController', async function ($scope, $element, $document, safeApply, cadSyncService) {

  $scope.loading = false
  $scope.unsignedDocs = []

  $scope.formatCreatedAt = (val) => {
    if (!val) return ''
    return moment(val).format('MM/DD/YYYY h:mm A')
  }

  $scope.copyLink = async (url) => {
    if (!url) return
    try {
      await navigator.clipboard.writeText(url)
      toastr.success('Link copied to clipboard')
    } catch (err) {
      console.log('copyLink failed :>> ', err)
      toastr.error('Could not copy link')
    }
  }

  // ---------------------------------------------------------------------------
  // Column filters (Excel-style)
  //
  // FILTER_COLUMNS lists the row field name + label for each filterable column.
  // $scope.colFilters[field] = { selected: Set<string>, search: '' }
  //   - selected: the set of values currently checked.
  //   - search: current search input for that column's popover.
  // $scope.openFilter holds the field name of the currently-open popover, or null.
  // ---------------------------------------------------------------------------

  const FILTER_COLUMNS = ['status', 'request_type', 'county_name', 'doc_set', 'cad_account', 'prop_id', 'user_id', 'situs', 'ownership_name', 'signers_name', 'signers_email']

  $scope.colFilters = {}
  $scope.openFilter = null

  // Cached per-field distinct values + cached filtered results keyed by search term.
  // Both invalidated by rebuildFilters().
  const distinctCache = {}
  const filteredCache = {}

  const valueToKey = (v) => (v === null || v === undefined || v === '') ? '__BLANK__' : String(v)
  const valueToLabel = (v) => (v === null || v === undefined || v === '') ? '(blank)' : String(v)

  function computeDistinct(field) {
    const seen = new Map()
    ;($scope.unsignedDocs || []).forEach(r => {
      const key = valueToKey(r[field])
      if (!seen.has(key)) seen.set(key, valueToLabel(r[field]))
    })
    return Array.from(seen.entries())
      .map(([key, label]) => ({ key, label }))
      .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }))
  }

  function rebuildFilters() {
    FILTER_COLUMNS.forEach(field => {
      distinctCache[field] = computeDistinct(field)
      filteredCache[field] = { search: '', list: distinctCache[field] }
      $scope.colFilters[field] = {
        selected: new Set(distinctCache[field].map(item => item.key)),
        search: '',
      }
    })
  }

  $scope.distinctValues = (field) => distinctCache[field] || []

  $scope.filteredDistinctValues = (field) => {
    const f = $scope.colFilters[field]
    if (!f) return []
    const term = (f.search || '').trim().toLowerCase()
    const cache = filteredCache[field]
    if (cache && cache.search === term) return cache.list
    const all = distinctCache[field] || []
    const list = term ? all.filter(item => item.label.toLowerCase().includes(term)) : all
    filteredCache[field] = { search: term, list }
    return list
  }

  $scope.isChecked = (field, key) => $scope.colFilters[field].selected.has(key)

  $scope.toggleValue = (field, key) => {
    const set = $scope.colFilters[field].selected
    if (set.has(key)) set.delete(key)
    else set.add(key)
  }

  $scope.selectAllVisible = (field) => {
    const set = $scope.colFilters[field].selected
    $scope.filteredDistinctValues(field).forEach(item => set.add(item.key))
  }

  $scope.selectNoneVisible = (field) => {
    const set = $scope.colFilters[field].selected
    $scope.filteredDistinctValues(field).forEach(item => set.delete(item.key))
  }

  // A filter is "active" if it deselects at least one value vs the full distinct set.
  $scope.isFilterActive = (field) => {
    const f = $scope.colFilters[field]
    if (!f) return false
    const all = $scope.distinctValues(field)
    return f.selected.size < all.length
  }

  $scope.toggleFilterDropdown = (field, $event) => {
    if ($event) $event.stopPropagation()
    $scope.openFilter = ($scope.openFilter === field) ? null : field
  }

  $scope.rowsFilter = (row) => {
    for (const field of FILTER_COLUMNS) {
      const f = $scope.colFilters[field]
      if (!f) continue
      if (!f.selected.has(valueToKey(row[field]))) return false
    }
    return true
  }

  // Close popover on outside click.
  const onDocClick = (e) => {
    if (!$scope.openFilter) return
    const target = e.target
    // Ignore clicks inside any open popover or the funnel trigger.
    if (target.closest && (target.closest('.col-filter-popover') || target.closest('.col-filter-trigger'))) return
    $scope.openFilter = null
    safeApply($scope)
  }
  $document.on('click', onDocClick)
  $scope.$on('$destroy', () => $document.off('click', onDocClick))

  $scope.refresh = async () => {
    if ($scope.loading) return
    $scope.loading = true
    safeApply($scope)
    const result = await cadSyncService.loadUnsignedDocs({})
    if (result.data.success) {
      $scope.unsignedDocs = result.data.data
    } else {
      console.log('loadUnsignedDocs failed :>> ', result.data.error)
    }
    rebuildFilters()
    $scope.loading = false
    safeApply($scope)
  }

  $scope.refresh()

})
